const PRO_ITEMS_COLUMNS = [
  { id: "name", label: "name", width: 250, fixed:'left', widget: "mediaText" },
  { id: "description", label: "Description", width: 300 },
  { id: "category", label: "CATEGORY", width: 200 },
  { id: "price", label: "PRICE", width: 150, widget: "number" },
  { id: "stock", label: "STOCK", width: 150, widget: "stock" },
  { id: "created", label: "CREATED", width: 200, widget: "date" },
  { id: "status", label: "STATUS", width: 200,  widget: "status" }
];

const COLUMNS_ATTACHMENTS = [
  {
    id: "name",
    label: "Name",
    width: 300,
    widget: "file"
  },{
    id: "createrProfile",
    label: "Owner",
    widget: "staticmember",
    width: 200
  },  {
    id: "lastModifiedDate",
    label: "Created At",
    widget: "date",
    width: 200
  }
];
  

const ROWS = [
  {
    name: "Wireless Mouse Pro",
    description: "Ergonomic wireless mouse with 2.4GHz connectivity, silent clicks, and adjustable DPI settings.",
    media: "https://encrypted-tbn0.gstatic.com/shopping?q=tbn:ANd9GcQdxvHpwLbBcZ9R4251ldhQXvkC5QJzeKz-1uNKbJoe6um8SGTvgb5EXg6qyvHEZvtPuiZeIV8DU6DLl6K5_2sZWnC3wjUkR6cjSOF7omsoqTOoK3_v3h0YxII",
    video: "http://example.com/videos/mouse01.mp4",
    category:'Mobile',
    price: 29.99,
    variationType: "Color",
    variation: ["Black", "White", "Gray"],
    quantity: 150,
    height: "4.5 cm",
    weight: "85 g",
    length: "11 cm",
    width: "6 cm"
  },
  {
    product: "Smartphone X1",
    description: "Latest 5G smartphone with AMOLED display, triple camera setup, and 128GB storage.",
    media: "http://example.com/images/smartphone01.png",
    video: "http://example.com/videos/smartphone01.mp4",
    price: 699.0,
    variationType: "Storage",
    variation: ["128GB", "256GB", "512GB"],
    quantity: 80,
    height: "7.5 cm",
    weight: "180 g",
    length: "15.8 cm",
    width: "7.6 cm",
    category:'tv',
    stock: 0,
    status: 1
  },
  {
    product: "Bluetooth Headphones Z2",
    description: "Over-ear wireless headphones with noise cancellation and 20-hour battery life.",
    media: "http://example.com/images/headphones.png",
    video: "http://example.com/videos/headphones.mp4",
    price: 129.99,
    variationType: "Color",
    variation: ["Black", "Blue", "Red"],
    quantity: 65,
    height: "18 cm",
    weight: "250 g",
    length: "20 cm",
    width: "15 cm",
    category:'tv',
    status: 2
  },
  {
    name: "4K Smart TV 55\"",
    description: "Ultra HD Smart TV with HDR10, Dolby Vision, and built-in streaming apps.",
    media: "http://example.com/images/tv.png",
    video: "http://example.com/videos/tv.mp4",
    price: 599.0,
    variationType: "Size",
    variation: ["43\"", "55\"", "65\""],
    quantity: 40,
    height: "70 cm",
    weight: "12 kg",
    length: "123 cm",
    width: "8 cm",
    category:'tv'
  },
  {
    name: "Gaming Laptop GX15",
    description: "15.6-inch gaming laptop with RTX 3060 GPU, 16GB RAM, and 1TB SSD.",
    media: "http://example.com/images/laptop.png",
    video: "http://example.com/videos/laptop.mp4",
    price: 1499.0,
    variationType: "RAM",
    variation: ["16GB", "32GB"],
    quantity: 25,
    height: "2.2 cm",
    weight: "2.3 kg",
    length: "35.7 cm",
    width: "25.0 cm",
    category:'tv'
  },
  {
    name: "Smartwatch FitX",
    description: "Fitness smartwatch with heart-rate monitoring, GPS, and waterproof design.",
    media: "http://example.com/images/smartwatch.png",
    video: "http://example.com/videos/smartwatch.mp4",
    price: 199.99,
    variationType: "Strap Color",
    variation: ["Black", "Pink", "Green"],
    quantity: 120,
    height: "1.2 cm",
    weight: "45 g",
    length: "4.5 cm",
    width: "3.8 cm",
    category:'mobile'
  },
  {
    name: "Mechanical Keyboard K200",
    description: "RGB backlit mechanical keyboard with Blue switches and detachable wrist rest.",
    media: "http://example.com/images/keyboard.png",
    video: "http://example.com/videos/keyboard.mp4",
    price: 89.99,
    variationType: "Switch Type",
    variation: ["Blue", "Brown", "Red"],
    quantity: 90,
    height: "3.8 cm",
    weight: "950 g",
    length: "44 cm",
    width: "13 cm",
    category:'tv'
  },
  {
    name: "Portable Bluetooth Speaker",
    description: "Waterproof Bluetooth speaker with 12-hour playtime and deep bass.",
    media: "http://example.com/images/speaker.png",
    video: "http://example.com/videos/speaker.mp4",
    price: 59.99,
    variationType: "Color",
    variation: ["Black", "Orange", "Camo"],
    quantity: 200,
    height: "7.5 cm",
    weight: "600 g",
    length: "19 cm",
    width: "7 cm"
  },
  {
    name: "Wireless Charger Pad",
    description: "Fast wireless charging pad compatible with Qi-enabled smartphones.",
    media: "http://example.com/images/charger.png",
    video: "http://example.com/videos/charger.mp4",
    price: 29.0,
    variationType: "Color",
    variation: ["Black", "White"],
    quantity: 300,
    height: "1.2 cm",
    weight: "150 g",
    length: "10 cm",
    width: "10 cm"
  },
  {
    name: "Drone ProX",
    description: "4K camera drone with 3-axis gimbal, GPS tracking, and 30-minute flight time.",
    media: "http://example.com/images/drone.png",
    video: "http://example.com/videos/drone.mp4",
    price: 799.0,
    variationType: "Battery",
    variation: ["1 Battery", "2 Batteries"],
    quantity: 15,
    height: "8 cm",
    weight: "1.2 kg",
    length: "25 cm",
    width: "20 cm"
  },
  {
    name: "Smart Home Hub",
    description: "Voice-controlled smart home hub with Wi-Fi and Zigbee support.",
    media: "http://example.com/images/hub.png",
    video: "http://example.com/videos/hub.mp4",
    price: 99.99,
    variationType: "Model",
    variation: ["Basic", "Pro"],
    quantity: 70,
    height: "5 cm",
    weight: "500 g",
    length: "12 cm",
    width: "12 cm"
  },
  {
    name: "Action Camera 4K",
    description: "Waterproof action camera with 4K recording and wide-angle lens.",
    media: "http://example.com/images/actioncam.png",
    video: "http://example.com/videos/actioncam.mp4",
    price: 249.0,
    variationType: "Bundle",
    variation: ["Standard", "Adventure Kit"],
    quantity: 60,
    height: "4 cm",
    weight: "200 g",
    length: "6.5 cm",
    width: "4.2 cm"
  },
  {
    name: "Tablet Plus 10",
    description: "10.1-inch Android tablet with 6GB RAM and 128GB storage.",
    media: "http://example.com/images/tablet.png",
    video: "http://example.com/videos/tablet.mp4",
    price: 399.0,
    variationType: "Storage",
    variation: ["128GB", "256GB"],
    quantity: 50,
    height: "0.8 cm",
    weight: "500 g",
    length: "24.5 cm",
    width: "15.3 cm"
  },
  {
    name: "DSLR Camera ProShot",
    description: "Professional DSLR camera with 24.2MP sensor and 4K video support.",
    media: "http://example.com/images/camera.png",
    video: "http://example.com/videos/camera.mp4",
    price: 1199.0,
    variationType: "Lens Kit",
    variation: ["Body Only", "18-55mm", "18-135mm"],
    quantity: 30,
    height: "9.8 cm",
    weight: "1.5 kg",
    length: "14.7 cm",
    width: "7.6 cm"
  },
  {
    name: "E-Book Reader Lite",
    description: "6-inch e-reader with backlight and 8GB storage for thousands of books.",
    media: "http://example.com/images/ereader.png",
    video: "http://example.com/videos/ereader.mp4",
    price: 129.0,
    variationType: "Color",
    variation: ["Black", "White"],
    quantity: 140,
    height: "0.8 cm",
    weight: "180 g",
    length: "16 cm",
    width: "11 cm"
  },
  {
    name: "Robot Vacuum CleanX",
    description: "Smart robot vacuum with app control, auto-charging, and voice assistant support.",
    media: "http://example.com/images/vacuum.png",
    video: "http://example.com/videos/vacuum.mp4",
    price: 499.0,
    variationType: "Model",
    variation: ["Standard", "Pro"],
    quantity: 45,
    height: "9.5 cm",
    weight: "3.5 kg",
    length: "35 cm",
    width: "35 cm"
  },
  {
    name: "Portable Monitor 15.6\"",
    description: "Full HD portable monitor with USB-C connectivity for laptops and smartphones.",
    media: "http://example.com/images/monitor.png",
    video: "http://example.com/videos/monitor.mp4",
    price: 229.0,
    variationType: "Resolution",
    variation: ["Full HD", "4K"],
    quantity: 55,
    height: "0.9 cm",
    weight: "1 kg",
    length: "36 cm",
    width: "22 cm"
  },
  {
    name: "Noise Cancelling Earbuds",
    description: "Wireless earbuds with ANC, touch controls, and wireless charging case.",
    media: "http://example.com/images/earbuds.png",
    video: "http://example.com/videos/earbuds.mp4",
    price: 149.0,
    variationType: "Color",
    variation: ["Black", "White", "Blue"],
    quantity: 180,
    height: "2.4 cm",
    weight: "60 g",
    length: "5 cm",
    width: "2.5 cm"
  },
  {
    name: "Smart Light Bulb",
    description: "Wi-Fi enabled smart bulb with color changing and voice assistant support.",
    media: "http://example.com/images/bulb.png",
    video: "http://example.com/videos/bulb.mp4",
    price: 19.99,
    variationType: "Pack",
    variation: ["1 Pack", "2 Pack", "4 Pack"],
    quantity: 400,
    height: "10.5 cm",
    weight: "70 g",
    length: "6 cm",
    width: "6 cm"
  }
];

const nameObject = { PRO_ITEMS_COLUMNS, ROWS, COLUMNS_ATTACHMENTS };
export default nameObject;